"use client";

import { Star } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface Roaster {
  id: number;
  name: string;
  logo: string;
  packageImage: string;
  googleRating: number;
  yotpoRating: number;
  averageRating: number;
  flavorProfile: string;
  websiteUrl: string;
}
const roastersData: Roaster[] = [{
  id: 1,
  name: "Gold Star Coffee",
  logo: "https://bestcoffeecanada.com/wp-content/uploads/2025/11/2024-Logo-2-Lines-Gold-Star-Coffee-Black-Text-Transparent.png",
  packageImage: "https://www.goldstarcoffee.ca/cdn/shop/files/rn-image_picker_lib_temp_b4709b80-d30f-4ba6-901a-623cb9e49bde.png?v=1763700210&width=1080",
  googleRating: 4.9,
  yotpoRating: 4.95,
  averageRating: 4.925,
  flavorProfile: "Award-winning single-origin beans with meticulous roasting profiles",
  websiteUrl: "https://www.goldstarcoffee.ca"
}, {
  id: 2,
  name: "49th Parallel Coffee Roasters",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/49th_parallel_coffee_roasters_logo.png",
  packageImage: "https://49thcoffee.com/cdn/shop/files/2025-Poppy-Barly_01_1460x1460.png?v=1756881140",
  googleRating: 4.8,
  yotpoRating: 4.75,
  averageRating: 4.775,
  flavorProfile: "Vancouver-based roaster specializing in direct-trade relationships and innovative brewing",
  websiteUrl: "https://www.49thcoffee.com"
}, {
  id: 3,
  name: "Monogram Coffee",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/monogram_coffee_logo.png",
  packageImage: "https://monogramcoffee.com/cdn/shop/files/warmth-filter_971a74d4-508e-4373-b8a9-929e6293db1c.png?v=1760562609&width=1000",
  googleRating: 4.8,
  yotpoRating: 4.7,
  averageRating: 4.75,
  flavorProfile: "Precision roasting with transparent sourcing and tasting notes",
  websiteUrl: "https://www.monogramcoffee.com"
}, {
  id: 4,
  name: "Pilot Coffee Roasters",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/pilot_coffee_roasters_logo.png",
  packageImage: "https://pilotcoffeeroasters.com/cdn/shop/files/Product_Badge_Heritage_300g_WB.jpg?v=1740712482&width=700",
  googleRating: 4.7,
  yotpoRating: 4.8,
  averageRating: 4.75,
  flavorProfile: "Urban roastery known for experimental blends and seasonal offerings",
  websiteUrl: "https://www.pilotcoffeeroasters.com"
}, {
  id: 5,
  name: "Hatch Coffee Roasters",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/hatch_coffee_roasters_logo.png",
  packageImage: "https://encrypted-tbn1.gstatic.com/shopping?q=tbn:ANd9GcQqMVIZD9ifeSeRQiPCw2wSf30N6QJEkS87UDBFNFFCDTQ_b9igH2tEkxuZ7V4wNw5SQHhmvmRv1EfsFVTQuxhc0FTSzyC3oA",
  googleRating: 4.7,
  yotpoRating: 4.75,
  averageRating: 4.725,
  flavorProfile: "Small-batch roaster dedicated to showcasing exceptional single-origin coffees with unique terroir",
  websiteUrl: "https://www.hatchcoffeeroasters.com"
}, {
  id: 10,
  name: "Green Coffee Traders",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/green_coffee_traders_logo.png",
  packageImage: "https://greencoffeetraders.ca/cdn/shop/products/GCT_-_1JBM_New_bag_1024x1024@2x.jpg?v=1598997086",
  googleRating: 4.7,
  yotpoRating: 4.75,
  averageRating: 4.725,
  flavorProfile: "Premium green coffee importers offering freshly roasted specialty beans with exceptional quality and traceability",
  websiteUrl: "https://www.greencoffeetraders.ca"
}, {
  id: 6,
  name: "De Mello Coffee",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/de_mello_coffee_logo.png",
  packageImage: "https://i0.wp.com/demellocoffee.com/wp-content/uploads/2025/10/de-mello-coffee-colombia-inza%CC%81-227.png?fit=900%2C900&ssl=1",
  googleRating: 4.7,
  yotpoRating: 4.65,
  averageRating: 4.675,
  flavorProfile: "Portuguese-inspired roastery with rich, full-bodied espresso blends",
  websiteUrl: "https://www.demellocoffee.com"
}, {
  id: 7,
  name: "Rogue Wave Coffee",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/rogue_wave_coffee_logo.png",
  packageImage: "https://eightouncecoffee.ca/cdn/shop/files/698c904b-ba9b-4c93-bff7-1903cc9b8157.png?v=1754579277&width=1000",
  googleRating: 4.7,
  yotpoRating: 4.65,
  averageRating: 4.675,
  flavorProfile: "Coastal-inspired roaster featuring bright, clean coffee profiles",
  websiteUrl: "https://www.roguewavecoffee.ca"
}, {
  id: 8,
  name: "Detour Coffee",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/detour_coffee_logo.png",
  packageImage: "https://detourcoffee.com/cdn/shop/files/DT-CoffeeBag_ElDuraznoGuatemala_1080x.png?v=1762969600",
  googleRating: 4.6,
  yotpoRating: 4.7,
  averageRating: 4.65,
  flavorProfile: "Community-focused roastery with rotating seasonal micro-lots",
  websiteUrl: "https://www.detourcoffee.com"
}, {
  id: 9,
  name: "Phil & Sebastian Coffee Roasters",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/phil_sebastian_coffee_roasters_logo.png",
  packageImage: "https://philsebastian.com/cdn/shop/files/JungleBerryOct-1.webp?v=1759527227&width=1400",
  googleRating: 4.6,
  yotpoRating: 4.6,
  averageRating: 4.6,
  flavorProfile: "Calgary-based roaster offering balanced, approachable specialty beans",
  websiteUrl: "https://www.philsebastian.com"
}];
const roasters = [...roastersData].sort((a, b) => b.averageRating - a.averageRating);
function RatingWidget({
  rating,
  delay
}: {
  rating: number;
  delay: number;
}) {
  const [displayRating, setDisplayRating] = useState(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.3
  });
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        let current = 0;
        const increment = rating / 20;
        const interval = setInterval(() => {
          current += increment;
          if (current >= rating) {
            setDisplayRating(rating);
            clearInterval(interval);
          } else {
            setDisplayRating(current);
          }
        }, 20);
        return () => clearInterval(interval);
      }, delay);
      return () => clearTimeout(timer);
    }
  }, [isVisible, rating, delay]);
  const fullStars = Math.floor(displayRating);
  const partialStar = displayRating - fullStars;
  return <div ref={ref} className="flex items-center gap-1">
      {[...Array(5)].map((_, i) => <div key={i} className="relative size-5">
          <Star className="absolute inset-0 size-5 text-muted" />
          {i < fullStars && <Star className="absolute inset-0 size-5 fill-accent text-accent" />}
          {i === fullStars && partialStar > 0 && <div className="absolute inset-0 overflow-hidden" style={{
        width: `${partialStar * 100}%`
      }}>
              <Star className="size-5 fill-accent text-accent" />
            </div>}
        </div>)}
      <span className="ml-2 text-sm font-semibold text-foreground">
        {displayRating.toFixed(2)}
      </span>
    </div>;
}
export default function RoasterGrid() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll<HTMLElement>({
    once: true,
    threshold: 0.1
  });
  return <section ref={sectionRef} className="bg-background px-6 py-16 md:px-12 md:py-24">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h1 className="font-display text-4xl font-bold text-foreground md:text-5xl">
            Top Specialty Coffee Roasters in Canada
          </h1>
          <p className="mt-4 text-lg text-muted-foreground">
            Curated based on Google Reviews and Yotpo ratings
          </p>
        </div>

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {roasters.map((roaster, i) => <Card key={roaster.id} data-index={i} className={`card group relative overflow-hidden border border-border bg-background p-0 shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1.5 hover:shadow-medium ${sectionVisible ? "animate-fade-in-up opacity-100" : "opacity-0"}`} style={{
          animationDelay: sectionVisible ? `${i * 50}ms` : "0ms"
        }}>
              <CardContent className="flex flex-col gap-6 p-6">
                <div className="flex items-center justify-center py-4">
                  {roaster.id === 10 ? <div className="text-center">
                      <div className="font-sans text-3xl font-bold tracking-wide text-black">
                        Green Coffee
                      </div>
                      <div className="font-sans text-2xl font-light tracking-widest text-black/80">
                        TRADERS
                      </div>
                    </div> : <img src={roaster.logo} alt={`${roaster.name} logo`} className="h-16 w-auto object-contain transition-transform duration-200 ease-[var(--ease-smooth)] group-hover:scale-[1.02]" />}
                </div>

                <div className="flex items-center justify-center">
                  <img src={roaster.packageImage} alt={`${roaster.name} coffee package`} className="h-48 w-auto object-contain rounded-lg transition-transform duration-200 ease-[var(--ease-smooth)] group-hover:scale-[1.05]" />
                </div>

                <div className="space-y-4">
                  <h2 className={roaster.id === 1 ? "font-sans text-3xl font-bold tracking-tight text-primary bg-gradient-to-r from-primary via-accent to-primary-hover bg-clip-text text-transparent" : roaster.id === 10 ? "font-sans text-2xl font-semibold tracking-wide text-black" : "font-display text-xl font-semibold text-foreground"}>
                    {roaster.name}
                  </h2>

                  <div className="space-y-3">
                    <div>
                      <p className="mb-1 text-xs font-medium uppercase tracking-wide text-muted-foreground">
                        Google Rating
                      </p>
                      <RatingWidget rating={roaster.googleRating} delay={0} />
                    </div>

                    <div>
                      <p className="mb-1 text-xs font-medium uppercase tracking-wide text-muted-foreground">
                        Yotpo Rating
                      </p>
                      <RatingWidget rating={roaster.yotpoRating} delay={100} />
                    </div>
                  </div>

                  <div className={`transition-opacity duration-200 ${sectionVisible ? "animate-fade-in-up-delay-200 opacity-100" : "opacity-0"}`}>
                    <p className="text-sm leading-relaxed text-muted-foreground">
                      {roaster.flavorProfile}
                    </p>
                  </div>
                </div>

                <Link to={roaster.websiteUrl} newTab>
                  <Button className="w-full rounded-md bg-primary px-6 py-3 font-semibold text-foreground-primary shadow-xs transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:-translate-y-0.5 hover:bg-primary-hover hover:shadow-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 active:translate-y-0 active:bg-primary-active" asChild>
                    <span>Visit Website</span>
                  </Button>
                </Link>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}